import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

const siteModeSchema = z.enum(['create', 'edit'])

export type SiteMode = z.infer<typeof siteModeSchema>

export const siteSearchParams = z.object({
  mode: siteModeSchema,
  [SEARCH_PARAM_ORG_ID]: z.string(),
  [SEARCH_PARAM_SITE_ID]: z.string().optional(),
})

export const createSiteSearch = (orgID: string) => ({
  mode: 'create' as const,
  [SEARCH_PARAM_ORG_ID]: orgID,
  [SEARCH_PARAM_SITE_ID]: undefined,
})

export const editSiteSearch = (orgID: string, siteID: string) => ({
  mode: 'edit' as const,
  [SEARCH_PARAM_ORG_ID]: orgID,
  [SEARCH_PARAM_SITE_ID]: siteID,
})
